import React from 'react';
import Loading from 'react-loading';
import '../../../css/Loading.css';

var LoruleLoading = function LoruleLoading(props) {
  var testId = props.testId;
  return /*#__PURE__*/React.createElement("div", {
    className: "loader",
    "data-testid": testId || 'loading'
  }, /*#__PURE__*/React.createElement(Loading, {
    color: "#E8001E"
  }));
};

export default LoruleLoading;